module.exports = __webpack_public_path__ + "img/suunto-movescount.8bac572c.png";